module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5aeeafc514f8643a6ac06aaa54e31043.png";